










































































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { ActivitySessionAttendee } from '@activities/interfaces/activity-session-attendee';
import NotifySummonsAttendeeModal from '@activities/components/modals/notify-summons-attendee-modal/notify-summons-attendee-modal.vue';

@Component({
  name: 'bpc-game-trip-summary-card',
  components: {
    'bpc-notify-summons-attendee-modal': NotifySummonsAttendeeModal,
  },
})
export default class GameTripSummaryCard extends Vue {
  // PROPS
  @Prop([String, Number]) readonly gameId: string | number;

  // DATA
  summons: ActivitySessionAttendee[] = null;
  showNotifySummonModal: boolean = false;
  attendeeIdsToNotify: number[] = [];
  attendeeSelectableCondition: string = null;

  // COMPUTED
  get totalCars() {
    return this.summons?.filter(item => item.trip === 'has_vehicle').length || 0;
  }
  get totalPlaces() {
    return this.summons
      ?.filter(item => item.trip === 'has_vehicle')
      .map(item => item.available_places)
      .reduce((partialSum, a) => partialSum + a, 0);
  }
  get totalDirect() {
    return this.summons?.filter(item => item.trip === 'going_directly').length || 0;
  }
  get totalNeedVehicle() {
    return this.summons?.filter(item => item.trip === 'need_vehicle').length || 0;
  }
  // LIFE CYCLE
  mounted() {
    this.getSummonedAttendees();
  }
  // METHODS
  getSummonedAttendees() {
    const queryConfig = {
      params: {
        summoned: 1,
        activity_session_id: this.gameId,
        per_page: -1,
      },
    };
    this.$bpcApi
      .get(this.$bpcApiRouteHelper.getEntityPath('activity-session-attendee'), queryConfig)
      .subscribe(
        (res: BPCGenericApiResponse) => {
          this.summons = res.data;
        },
        error => {
          console.log(error);
        },
      );
  }

  openNotifySummonModal(action) {
    switch (action) {
      case 'has_vehicle':
        this.attendeeSelectableCondition = 'has_vehicle';
        this.attendeeIdsToNotify = this.summons
          ?.filter(item => item.trip === 'has_vehicle')
          .map(item => item.id);
        break;
      case 'need_vehicle':
        this.attendeeSelectableCondition = 'need_vehicle';
        this.attendeeIdsToNotify = this.summons
          ?.filter(item => item.trip === 'need_vehicle')
          .map(item => item.id);
        break;
      case 'going_directly':
        this.attendeeSelectableCondition = 'going_directly';
        this.attendeeIdsToNotify = this.summons
          ?.filter(item => item.trip === 'going_directly')
          .map(item => item.id);
        break;
      default:
        this.attendeeSelectableCondition = null;
        this.attendeeIdsToNotify = this.summons?.map(item => item.id);
    }
    this.showNotifySummonModal = true;
  }

  onCloseAddSummonModal() {
    this.showNotifySummonModal = false;
    this.attendeeIdsToNotify = [];
    this.attendeeSelectableCondition = null;
  }

  // WATCHERS
}
